import { ErroDaApi } from "app/api/classes/ErroDaApi"
import globalMU from "globalMU"

export function tratamentoErroPadrao(erro:any) {
    if (erro instanceof ErroDaApi) {
        globalMU.showErrorMessage(erro.Error)
    } else {
        globalMU.showErrorMessage("Houve um erro desconhecido")
        console.error(erro)
    }
}